<template>
  <div :class="$style.page">
    <div :class="$style.header">
      <img
        src="@/assets/icon.png"
        :class="[$style.logo]"
        @click="$router.push('/')"
      >
      <!-- <img
        :class="$style.coverShadow"
        :src="thisArticle.cover"
      > -->
      <div :class="$style.articleTitle">
        <br><br><br><br><br><br><br><br><br>
        <h1
          :class="$style.title"
          v-html="title"
        >
        </h1>
        <br>
        <h2 :class="$style.subtitle">{{ thisArticle.subtitle }}</h2>
      </div>
      <img
        :class="$style.cover"
        :src="thisArticle.cover"
      >
    </div>
    <!-- <div
      :class="$style.kv"
      v-if="this.thisArticle"
    >
      <div :class="$style.articleTitle">
        <h1
          :class="$style.title"
          v-html="title"
        >
        </h1>
        <br>
        <h2 :class="$style.subtitle">{{ thisArticle.subtitle }}</h2>
      </div>
    </div> -->
    <ArticleRenderer
      :data="mainContent"
      :class="$style.article"
    />
    更多出行与汽车（重点标签）
    联系入口
  </div>
</template>

<script>
import ArticleRenderer from '@/components/ArticleRenderer.vue'
export default {
  name: 'Article',
  components: {
    ArticleRenderer
  },
  data () {
    return {
      articles: [],
      mainContent: {}
    }
  },
  computed: {
    thisArticle () {
      let res
      for (let index = 0; index < this.articles.length; index++) {
        let element = this.articles[index]
        if (element.articleId === this.$route.params.articleId) {
          res = element
          break
        }
      }
      return res
    },
    title () {
      let res = this.thisArticle && this.thisArticle.title
      if (res) {
        res = res.replace(' ', '<br>')
      }
      return res
    }
  },
  methods: {
    getArticlesData () {
      this.$cloud.query('/data/articles.json', data => {
        let res = data.list
        this.articles = res
      })
    },
    getArticle () {
      this.$cloud.query(`/data/article.${this.$route.params.articleId}.json`, data => {
        let res = data
        this.mainContent = res
      })
    }
  },
  created () {
    this.getArticlesData()
    this.getArticle()
  }
}
</script>

<style module>
.page {
    min-height: 100vh;
}

.header {
  position: relative;
    margin: 0 auto;
    margin-top: 72px;
    width: 100%;
    max-width: 1200px;
    padding-left: 200px;
    box-sizing: border-box;

    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.logo {
  position: relative;
  z-index: 1;
  width: 56px;
  cursor: pointer;
  /* height: 43px; */
}

.kv {
    position: relative;
    margin: 0 auto;
    /* background: rgba(255, 0, 0, .2); */
    margin-top: 24px;
    width: 100%;
    max-width: 1000px;
    /* display: flex; */
    /* flex-direction: column; */
    /* justify-content: center; */
    /* align-items: center; */
    /* background: rgba(255,0,0,.3); */
}

.articleTitle {
  position: absolute;
  /* left: 0; */
  bottom: 0;
  /* background: rgba(255,0,0,.3); */
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content:flex-end;
  justify-content: center;

}

.title {
    font-size: 56px;
    word-break: break-all;
}

.subtitle {
    font-size: 22px;
    opacity: .5;
}

.cover {
  position: relative;
    width: 600px;
    height: 600px;
    object-fit: cover;
    /* border: solid 10px rgb(39, 39, 39); */
    /* opacity: .2; */
}
/* .coverShadow {
  position: absolute;
  right: 0;
  width: 600px;
  height: 600px;
  object-fit: cover;
  filter: blur(134px);
  opacity: .5;
} */

.article {
  margin: 0 auto;
  margin-top: 96px;
  margin-bottom: 87px;

  padding: 64px;
  /* width: 100%; */
  /* max-width: 720px; */
}
</style>
